// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signup[data-v-4aef6414]{margin:auto auto;max-width:480px}h3[data-v-4aef6414]{margin:40px 0 0}ul[data-v-4aef6414]{list-style-type:none;padding:0}li[data-v-4aef6414]{display:inline-block;margin:0 10px}a[data-v-4aef6414]{color:#42b983}.checkbox[data-v-4aef6414]{margin-bottom:14px}.checkbox .help[data-v-4aef6414]{margin-top:14px}.help[data-v-4aef6414]{margin:0 0 5px 0;font-size:.95rem}#exampleInputEmail1[data-v-4aef6414]{width:100%}", ""]);
// Exports
module.exports = exports;
